import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { Box, Chip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Download, Edit, Users, X } from "lucide-react";
import type React from "react";

const FilterContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginLeft: theme.spacing(2),
}));

const StyledChip = styled(Chip)(({ theme }) => ({
    padding: theme.spacing(0.5, 0),
    height: "auto",
    "& .MuiChip-label": {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(0, 1.5),
    },
    "& .MuiChip-deleteIcon": {
        margin: theme.spacing(0, 0.5),
    },
}));

interface FilterBadgeProps {
    filterName?: string;
    onClear: () => void;
    onEdit: () => void;
    onExport: () => void;
    onBulkReassign: () => void;
}

const FilterBadge: React.FC<FilterBadgeProps> = ({
    filterName,
    onClear,
    onEdit,
    onExport,
    onBulkReassign,
}) => {
    const { hasPermission } = useEmployee();

    return (
        <FilterContainer>
            <Typography variant="body2" color="text.secondary">
                Active Filter:
            </Typography>
            <StyledChip
                label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>{filterName || "Custom Filter"}</span>
                        <Edit
                            size={14}
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit();
                            }}
                            style={{ cursor: "pointer" }}
                        />
                        <Download
                            size={14}
                            onClick={(e) => {
                                e.stopPropagation();
                                onExport();
                            }}
                            style={{ cursor: "pointer" }}
                        />

                        {hasPermission("bulk-assign:case-task") && (
                            <Users
                                size={14}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onBulkReassign();
                                }}
                                style={{ cursor: "pointer" }}
                            />
                        )}
                    </Box>
                }
                onDelete={onClear}
                deleteIcon={<X size={14} />}
                color="primary"
                variant="outlined"
                size="small"
            />
        </FilterContainer>
    );
};

export default FilterBadge;
